define('widgets/select',[
	'jquery',
	'lib/jquery-ui/widget'
], function ($) {

	return $.widget('muse.select', {

		options: {
		},

		_create: function () {

			this.$current = this.element.find('.current');
			this.$select = this.element.find('select');

			this._on(this.$select, {
				'change': 'onChange'
			});

			return this._super();

		},

		onChange: function () {

			var val = this.$select.find(':selected').text();
			this.$current.text(val);

		}

	});

});
